import {lazy} from 'react';
import LazyComponent from 'components/LazyComponent';

export default [
  {
    component: LazyComponent(lazy(() => import('./List'))),
    path: '/topic/list',
  },
  {
    component: LazyComponent(lazy(() => import('./Create'))),
    path: '/topic/create',
  },
  {
    component: LazyComponent(lazy(() => import('./Update'))),
    path: '/topic/update/:id',
  },
];
